import { PersonsTagsDTO } from "../dto/PersonTags";
import { TagDTO } from "../dto/TagDTO";
import { AssignedTag, Tag } from "../models/Person/Tag";

// Tags that come straight from the API
export const tagMapper = (dto: TagDTO) => {
  return new Tag({
    id: dto.tagId,
    name: dto.tagName,
    active: dto.active === "Y" ? true : false,
  });
};

// Tags that are assigned to a Person pulled from the PersonDTO
export const assignedTagMapper = (dto: PersonsTagsDTO) => {
  return new AssignedTag({
    id: dto.tag.tagId,
    name: dto.tag.tagName,
    active: dto.tag.active === "Y" ? true : false,
    assignId: dto.assignId,
  });
};
